module.exports = __webpack_public_path__ + "static/pic2-3883b6382ec9cd6788331b0ee9d602a8.jpg";